import React, { useState } from 'react';
import { Box } from '@mui/material';
import { ConversationHeader } from './ConversationHeader';
import { MessageList } from './MessageList';
import { MessageInput } from './MessageInput';
import { useMessaging } from '../../contexts/MessagingContext';

interface ConversationViewProps {
  onBack?: () => void;
}

/**
 * ConversationView Component
 *
 * Main conversation view that combines:
 * - ConversationHeader (top bar)
 * - MessageList (message feed)
 * - MessageInput (compose area)
 *
 * Handles reply state management
 */
export const ConversationView: React.FC<ConversationViewProps> = ({ onBack }) => {
  const { activeConversation, activeConversationId } = useMessaging();
  const [replyToMessageId, setReplyToMessageId] = useState<string | null>(null);

  if (!activeConversation || !activeConversationId) {
    return null;
  }

  const handleReply = (messageId: string): void => {
    setReplyToMessageId(messageId);
  };

  const handleClearReply = (): void => {
    setReplyToMessageId(null);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {/* Header */}
      <ConversationHeader conversation={activeConversation} onBack={onBack} />

      {/* Messages */}
      <MessageList conversationId={activeConversationId} onReply={handleReply} />

      {/* Input */}
      <MessageInput
        conversationId={activeConversationId}
        replyTo={replyToMessageId}
        onClearReply={handleClearReply}
      />
    </Box>
  );
};
